"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardRowButtonSet_1 = require("../../../../../../../shared/components/editors/CardRowButtonSet");
var notificationHelper_1 = require("../../../../../../../shared/helpers/notificationHelper");
var CardEditorContainer_1 = require("../../../../../../../shared/components/containers/CardEditorContainer");
var CardRowNumericEditor_1 = require("../../../../../../../shared/components/editors/CardRowNumericEditor");
var CardRowButtonTextEditor_1 = require("../../../../../../../shared/components/editors/CardRowButtonTextEditor");
var JackpotWinHistoryEditor = /** @class */ (function (_super) {
    __extends(JackpotWinHistoryEditor, _super);
    function JackpotWinHistoryEditor(props) {
        var _this = _super.call(this, props) || this;
        _this.SID = 0;
        return _this;
    }
    JackpotWinHistoryEditor.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.dataPlayersAvail.Subscribe("*", function (id, data) {
            _this.setState({
                players_list: data.data
            }, function () {
                _this.props.dlgSelectPlayer.SetViewData(_this.state.players_list);
            });
        });
        this.setState({
            usr_player_id: 0,
            usr_player_login: "",
            jp_amount: 0,
            players_list: [],
            filterData: ""
        }, function () {
            _this.props.state.setExtBreadCrumbPath(["\u0418\u0441\u0442\u043E\u0440\u0438\u044F \u0432\u044B\u0438\u0433\u0440\u044B\u0448\u0435\u0439 \u0434\u0436\u0435\u043A\u043F\u043E\u0442\u043E\u0432 - [" + _this.props.rootRecord.title + "]", "Создание истории выигрыша"]);
            _this.props.dataPlayersAvail.LoadData(_this.props.rootRecord.brand_id, _this.state.filterData);
        });
        this.doReSetRules();
    };
    JackpotWinHistoryEditor.prototype.componentWillUnmount = function () {
        this.props.data.UnSubscribe(this.SID);
    };
    JackpotWinHistoryEditor.prototype.doReSetRules = function () {
        this.setState({
            usr_player_rules: { isError: false },
            jp_amount_rules: { isError: false }
        });
    };
    JackpotWinHistoryEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        if ((this.state.usr_player_id <= 0) || (this.state.usr_player_login.length === 0)) {
            this.setState({ usr_player_rules: { isError: true, errorMessage: "Игрок не выбран!" } });
            return false;
        }
        if (this.state.jp_amount <= 0) {
            this.setState({ jp_amount_rules: { isError: true, errorMessage: "Сумма указана некорректно!" } });
            return false;
        }
        return true;
    };
    JackpotWinHistoryEditor.prototype.OnNewDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.AddData({
                bonusJackpotId: this.props.rootRecord.key,
                usrPlayerId: this.state.usr_player_id,
                amountInJpCurrency: this.state.jp_amount
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("История выигрыша джекпота добавлена!");
            });
        }
    };
    JackpotWinHistoryEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    JackpotWinHistoryEditor.prototype.getFormTitle = function () {
        return "Новый элемент истории выигрыша джекпота";
    };
    JackpotWinHistoryEditor.prototype.doSelectPlayer = function () {
        var _this = this;
        this.props.dlgSelectPlayer
            .SetViewData(this.state.players_list)
            .SetOnSelectClick(function (key, value) {
            _this.setState({
                usr_player_id: key,
                usr_player_login: value,
                usr_player_rules: { isError: false }
            }, function () {
                _this.props.dlgSelectPlayer.Close();
            });
        }).SetOnReLoadData(function (filter) {
            _this.setState({
                filterData: filter
            }, function () {
                _this.props.dlgSelectPlayer.SetFilterVal(_this.state.filterData);
                _this.props.dataPlayersAvail.LoadData(_this.props.rootRecord.brand_id, _this.state.filterData);
            });
        }).SetOnCloseClick(function () {
            _this.props.dlgSelectPlayer.Close();
        })
            .SetTitle("Выберите игрока")
            .SetColumnValueTitle("Логин")
            .Show();
    };
    JackpotWinHistoryEditor.prototype.render = function () {
        var _this = this;
        return (React.createElement(CardEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 280 },
            React.createElement(CardRowButtonTextEditor_1.default, { texts: { caption: "Игрок:", placeholder: "Выберите игрока", buttonHint: "Выберите игрока" }, readonly: true, onButtonClick: this.doSelectPlayer.bind(this), onValueChanged: null, value: this.state.usr_player_login, buttonIcon: "user", rules: this.state.usr_player_rules, required: true, disabled: false }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Сумма выигрыша", placeholder: "Введите сумму выигрыша" }, values: { max: 9999999, min: 0.01, value: this.state.jp_amount }, onValueChanged: function (newVal) {
                    _this.setState({
                        jp_amount: newVal,
                        jp_amount_rules: { isError: false }
                    });
                }, required: true, precision: 2, rules: this.state.jp_amount_rules }),
            React.createElement(CardRowButtonSet_1.default, { editMode: false, title: { btnNew: "Создать", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnNewDataClick.bind(this) })));
    };
    return JackpotWinHistoryEditor;
}(React.Component));
exports.default = JackpotWinHistoryEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_jackpots/ui/component/win_history/JackpotWinHistoryEditor.tsx
// module id = 2350
// module chunks = 0